import { z } from 'zod'
import { oc } from '@orpc/contract'

export const healthcheckUser = oc.route({ method: 'GET', path: '/v2/healthcheck-user' }).output(
  z.object({
    status: z.literal('ok'),
    user: z.object({
      profile: z.object({ reference: z.string() }),
    }),
    patients: z.object({ total: z.number() }),
  }),
)
